import i18next from 'i18next'
import { defer } from 'lodash'
import React from 'react'
/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { sidebarDirection } from './configs'
import { comboTextByOS, findNodeAndPathByIdFromTreeData, openNewWindowAtWindow2 } from './functions'
import { globalOnDemandVars } from './context'
import { getIdForRenderTileInJSON } from '../components/list/window2/functions'
import { mutateAddOnAsync, mutateAddOnAsyncDebounced } from '../backend/addons/updateData'
import { nodeDefaultSizeWithoutSubtitle, nodeDefaultSizeWithSubtitle } from './variables'
import * as shortid from 'shortid'
import { getInitialRecordProperty } from '../logic/SM2+'
import { dragHandlerHeight, dragHandlerHeightForPixel } from '../components/addon/sidebar/box'
import { nanoid } from 'nanoid'

export class Key {
  constructor (text, combo, eventHandler, icon, active, config) {
    this.text = text
    this.combo = combo
    this.eventHandler = eventHandler
    this.icon = icon
    this.active = active
    this.comboForText = comboTextByOS(combo)
    this.config = config || {}

    this.isForHotKey = Boolean(combo)
    this.isForMenu = Boolean(icon)
  }
  returnPropObjForHotKey () {
    return (!this.isForHotKey ? null : {
      combo: this.combo,
      label: this.text,
      onKeyDown: this.eventHandler,
      key: this.combo,
      stopPropagation: true
    })
  }
  returnPropObjForMenuItem () {
    return (!this.isForMenu ? null : {
      text: i18next.t(this.text),
      onClick: this.eventHandler,
      icon: this.icon,
      labelElement: (this.combo ? (<span className={'bp3-code'} css={css`opacity: 0.8; font-size: var(--s-1);`}>{this.comboForText}</span>) : null),
      active: this.active,
      title: this.text + (this.comboForText ? `(${this.comboForText})` : ''),
      key: this.icon || this.text
    })
  }
  returnPropsObjForButton (hasText) {
    return (!this.isForMenu ? null : {
      text: hasText ? i18next.t(this.text) : null,
      onClick: this.eventHandler,
      icon: this.icon,
      active: this.active,
      title: this.text + (this.comboForText ? `(${this.comboForText})` : ''),
      key: this.icon || this.text
    })
  }
}

export class OneNode {
  constructor (id, offNewOne) {
    this.id = id || nanoid()
    // globalOnDemandVars.booleanOfIsThisNewOne()[id] = true
    this.title = ''
    this.subtitle = ''
    this.height = globalOnDemandVars.knowledgeTreeMode() === 'reference' ? nodeDefaultSizeWithoutSubtitle : nodeDefaultSizeWithSubtitle
    this.expanded = true

    // const { difficulty, update, interval } = getInitialRecordProperty()
    // this.difficulty = difficulty
    // this.update = update
    // this.interval = interval

    this.isNewOne = offNewOne ? false : {
      boolean: true,
      boolean2: true
    }
    this.editableValues = {
      orderAsChild: 0,
      ...(getInitialRecordProperty())
    }

    this.decorating = {}
  }
}

export class NodeById {
  constructor (id) {
    this.id = id
  }

  getNode (inPixelMode, treeData) {
    const nodeAndPathArray = findNodeAndPathByIdFromTreeData(this.id, treeData || (inPixelMode ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()))

    return nodeAndPathArray ? (nodeAndPathArray[0] || false) : false
  }

  getPath (inPixelMode, treeData) {
    const nodeAndPathArray = findNodeAndPathByIdFromTreeData(this.id, treeData || (inPixelMode ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()))

    return nodeAndPathArray ? (nodeAndPathArray[1] || false) : false
  }

  getNodeAndPath (inPixelMode, treeData) {
    const nodeAndPathArray = findNodeAndPathByIdFromTreeData(this.id, treeData || (inPixelMode ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()))

    return nodeAndPathArray || false
  }

  getTitle (inPixelMode, treeData) {
    if (this.id === 'rootNode') {
      return globalOnDemandVars.topRootName()
    }
    const nodeAndPathArray = findNodeAndPathByIdFromTreeData(this.id, treeData || (inPixelMode ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()))
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'findNodeById getTitle',
        preview: this.id,
        value: {
          id: this.id,
          findNode: nodeAndPathArray
        }
      // , important: true
      })
    }
    return nodeAndPathArray ? nodeAndPathArray[0].title : false
  }

  onClick (inPixelMode, treeData) {
    if (process.env.NODE_ENV !== 'production') {
      console.tron.display({
        name: 'findNodeById onClick',
        preview: this,
        value: {
          thisValue: this
        }
      // , important: true
      })
    }
    const pathOfWindow2 = this.id === 'rootNode' ? [] : findNodeAndPathByIdFromTreeData(this.id, treeData || (inPixelMode ? globalOnDemandVars.pixelTreeData() : globalOnDemandVars.globalTreeData()))[1]
    if (pathOfWindow2) {
      const nextTileId = getIdForRenderTileInJSON(shortid.generate(), pathOfWindow2)
      openNewWindowAtWindow2(nextTileId, sidebarDirection === 'left')
    }
  }
}

export class BoxClass {
  constructor (contentComponent, title, props, role, { hasCustomDialogComponent, customDialogComponent, initialHeight, backgroundColor, isFavorite, order, favoriteOrder, dialogType, onlyForTheseLocations, letItBePixel, defaultOpen, inSharingMode }) {
    this.props = props
    this.contentComponent = contentComponent
    this.title = title
    this.id = title
    this.role = role
    // TODO customDialogComponent가 있을 때 dialog로 이걸 띄우게 해야함
    this.customDialogComponent = customDialogComponent
    this.hasCustomDialogComponent = hasCustomDialogComponent || Boolean(customDialogComponent)
    this.backgroundColor = backgroundColor
    this.isFavorite = isFavorite || false
    this.order = order
    this.favoriteOrder = favoriteOrder || 0
    this.dialogType = dialogType
    // this.defaultOpen = defaultOpen

    const defaultInitialHeight = 200
    // this.defaultInitialHeight = defaultInitialHeight
    this.initialHeight = (defaultOpen) ? (initialHeight || defaultInitialHeight) : (letItBePixel ? dragHandlerHeightForPixel : dragHandlerHeight)
    this.initialHeightForFavorite = initialHeight || defaultInitialHeight
    this.heightBeforeMinimize = initialHeight || defaultInitialHeight
    this.heightBeforeMinimizeForFavorite = initialHeight || defaultInitialHeight

    this.letItBePixel = letItBePixel
    this.onlyForTheseLocations = onlyForTheseLocations
    this.inSharingMode = inSharingMode
    // -----------------------------------------------------------------------------------------------------------

    this.inputObjForUpdatingCloud = () => {
      return {
        order: this.order,
        favoriteOrder: this.favoriteOrder,
        initialHeight: this.initialHeight,
        initialHeightForFavorite: this.initialHeightForFavorite,
        isFavorite: this.isFavorite
      }
    }

    this.setOrder = (order) => {
      if (this.order !== order) {
        this.order = order
        defer(() => {
          mutateAddOnAsync(this.id, this.inputObjForUpdatingCloud())
        })
      }
    }
    this.setFavoriteOrder = (order) => {
      if (this.order !== order) {
        this.favoriteOrder = order
        if (process.env.NODE_ENV !== 'production') {
          console.tron.display({
            name: 'setFavoriteOrder',
            preview: this.id,
            value: {
              id: this.id,
              favoriteOrder: this.favoriteOrder,
              inputObjForUpdatingCloud: this.inputObjForUpdatingCloud()
            }
          // , important: true
          })
        }
        // mutateAddOnAsyncDebounced(this.id, this.inputObjForUpdatingCloud())
        defer(() => {
          mutateAddOnAsync(this.id, this.inputObjForUpdatingCloud())
        })
      }
    }
    this.incrementFavoriteOrder = () => {
      this.setFavoriteOrder(this.favoriteOrder + 1)
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'appsync / incrementFavoriteOrder',
          preview: this.id,
          value: {
            favoriteOrder: this.favoriteOrder
          }
        // , important: true
        })
      }
    }
    this.decrementFavoriteOrder = () => {
      this.setFavoriteOrder(this.favoriteOrder - 1)
      if (process.env.NODE_ENV !== 'production') {
        console.tron.display({
          name: 'appsync / decrementFavoriteOrder',
          preview: this.id,
          value: {
            favoriteOrder: this.favoriteOrder
          }
        // , important: true
        })
      }
    }

    this.setInitialHeight = (nextH) => {
      this.initialHeight = nextH
      mutateAddOnAsyncDebounced(this.id, this.inputObjForUpdatingCloud())
    }
    this.setInitialHeightForFavorite = (nextH) => {
      this.initialHeightForFavorite = nextH
      mutateAddOnAsyncDebounced(this.id, this.inputObjForUpdatingCloud())
    }
    this.setHeightBeforeMinimize = (nextH, isFavorite) => {
      if (isFavorite) {
        this.heightBeforeMinimizeForFavorite = nextH
      } else {
        this.heightBeforeMinimize = nextH
      }
    }
    this.setNextProps = (nextProps) => {
      this.props = Object.assign(this.props, nextProps)
    }
    this.setFavorite = (boolean) => {
      this.isFavorite = boolean
      if (!boolean) {
        this.favoriteOrder = 1
      }
      mutateAddOnAsyncDebounced(this.id, this.inputObjForUpdatingCloud())
    }
    this.setFromCloud = ({ order, favoriteOrder, initialHeight, initialHeightForFavorite, isFavorite }) => {
      this.order = order
      this.favoriteOrder = favoriteOrder
      this.initialHeight = initialHeight
      this.initialHeightForFavorite = initialHeightForFavorite
      this.isFavorite = isFavorite
    }
  }

  // 왜그런지 모르겠는데 밑에처럼 method 만들었을 때 안쪽에서 this 참조못해서 undef 됨
  // setInitialHeight (nextH) {
  //   this.initialHeight = nextH
  // }
  // setNextProps (nextProps) {
  //   this.props = Object.assign(this.props, nextProps)
  // }
}
